import { Box, Button, Stack } from "@mui/material";
import { X } from "react-feather";
import LogChat from "./LogChat";

export default function LogChatDetail({
    id,
    onClose,
}: {
    id: number,
    onClose?: () => void,
}) {
    return <Stack
            sx={{
                padding: 2,
                flexGrow: 1,
            }}
        >
            <Stack
                direction='row'
                sx={{
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
            >
                <Box></Box>
                <Button
                     onClick={() => {
                        if (onClose) { onClose() }
                    }}
                >
                    <X />
                </Button>
            </Stack>
            <Stack
                sx={{
                    flexGrow: 1,
                }}
            >
                {id > -1 && <LogChat
                    id={id}
                    initDisplaySize='normalItems'
                />}
            </Stack>
        </Stack>
}
